<template>
  <div id="app">
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <loadingcomp
      ref="loadingcomp"
      v-bind:mesaj="loadingmesaj"
      v-model="loadingdialog"
    ></loadingcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 md12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title v-if="islemTipi == 'new'"
              >Otel Fiyat Ekle</v-toolbar-title
            >
            <v-toolbar-title v-if="islemTipi == 'get'"
              >Otel Fiyat Güncelle</v-toolbar-title
            >
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                v-if="islemTipi == 'new'"
                slot="activator"
                class="white--text"
                @click="kaydet()"
                flat
              >
                <span class="hidden-sm-and-down">{{ $t("save_button") }}</span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">Ekle</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Update"
                v-if="islemTipi == 'get'"
                slot="activator"
                class="white--text"
                @click="guncelle()"
                flat
              >
                <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                <v-icon right dark>system_update_alt</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 md12 sm12>
          <v-tabs
            style="width: 100%"
            dark=""
            v-model="active"
            color="info"
            background-color="grey lighten-4"
            slot="extension"
            slider-
          >
            <v-tabs-slider></v-tabs-slider>
            <div class="v-tabs__div">
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <a class="v-tabs__item" v-on="on">
                    {{ $t('Price-Details-v3') }} <v-icon>arrow_drop_down</v-icon>
                  </a>
                </template>
                <v-list class="grey lighten-3">
                  <v-list-tile>
                    <v-tab href="#0" @click="activeTab(0)"> {{ $t('Adult') }} </v-tab>
                  </v-list-tile>
                  <v-list-tile v-show="tabShow">
                    <v-tab href="#2" @click="activeTab(2)"> {{ $t('Child') }} 1 </v-tab>
                  </v-list-tile>
                  <v-list-tile v-show="tabShow">
                    <v-tab href="#3" @click="activeTab(3)"> {{ $t('Child') }} 2 </v-tab>
                  </v-list-tile>
                  <v-list-tile v-show="tabShow">
                    <v-tab href="#4" @click="activeTab(4)"> {{ $t('Child') }} 3 </v-tab>
                  </v-list-tile>
                  <v-list-tile v-show="tabShow">
                    <v-tab href="#5" @click="activeTab(5)"> {{ $t('Child') }} 4 </v-tab>
                  </v-list-tile>
                  <v-list-tile v-show="tabShow">
                    <v-tab href="#6" @click="activeTab(6)"> {{ $t('Extra-Bed') }} </v-tab>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
            <v-tab href="#1">   {{ $t('Commission-Current-Details') }} </v-tab>
          </v-tabs>
          <v-card flat color="grey lighten-4">
            <v-card-text>
              <v-flex xs12 sm12 md12 pa-2>
                <v-card light>
                  <v-card-title primary title>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class="project overdue">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title>
                            <span class="headline black--text font-weight-bold">
                              {{ $t('General-Information') }}
                            </span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="GenelBilgiler" v-model="valid" lazy-validation>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md4>
                          <v-layout align-center justify-start>
                            <v-flex xs12 sm12 md6>
                              <tarihim
                                :etiket="$t('Starting-Date')"
                                v-model="otelData.Id.Donem1"
                                :detaygizle="false"
                                v-bind:defaultvalue="'no'"
                                :rules="[
                                  (v) =>
                                    !!v || $t('Please-Enter-Starting-Date'),
                                ]"
                              ></tarihim>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <tarihim
                                :etiket="$t('Finishing-Date')"
                                v-model="otelData.Id.Donem2"
                                :detaygizle="false"
                                v-bind:defaultvalue="'no'"
                                :rules="[
                                  (v) => !!v || $t('Please-Enter-Finishing-Date'),
                                ]"
                              ></tarihim>
                            </v-flex>
                          </v-layout>
                          <v-layout align-center justify-start>
                            <v-flex xs12 sm12 md6>
                              <genelarama
                                apiname="SaticiAra"
                                @input="fiyatKonumList()"
                                v-model="otelData.Id.SaticiKodu"
                                :tip="1"
                                :label="$t('Hotel')"
                              ></genelarama>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <geneltipara
                                tip="OtelFiyatKod"
                                v-model="otelData.Id.FiyatKodu"
                                label="fiyatKodu :"
                              ></geneltipara>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-layout align-center justify-center>
                            <v-flex xs12 sm12 md6>
                              <v-select
                                hide-details=""
                                :items="Pansiyonitems"
                                v-model="otelData.Id.Pansiyon"
                                item-text="text"
                                item-value="value"
                                clearable
                                label="Pansiyon"
                              >
                              </v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-select
                                hide-details=""
                                :items="RPitems"
                                @input="tabShowView()"
                                v-model="otelData.OtelFiyat.GrupBilgi.RP"
                                item-text="text"
                                item-value="value"
                                clearable
                                label="R / P"
                              >
                              </v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout align-center justify-center>
                            <v-flex xs12 sm12 md6 mt-1>
                              <genelarama
                                apiname="SaticiAra"
                                :tip="12"
                                v-model="otelData.Id.TurOperatoru"
                                :label="$t('Tour-Operator') +':'"
                              ></genelarama>
                            </v-flex>
                            <v-flex xs6 sm3 md6 mt-3>
                              <v-checkbox
                                :label="$t('Web-Active')"
                                v-model="otelData.OtelFiyat.GrupBilgi.WebActive"
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-layout row wrap align-center justify-start>
                            <v-flex xs12 sm1 md2>
                              <span
                                class="subheading red--text font-weight-bold"
                              >
                                {{$t('Sales')}}&nbsp;:</span
                              >
                            </v-flex>
                            <v-flex xs12 sm5 md6>
                              <span>
                                <v-select
                                  dense
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.ParaBirimi
                                  "
                                  class="basic"
                                  :items="doviztipi"
                                  @input="getKur('satis')"
                                  item-text="Title"
                                  item-value="DovizKod"
                                  :label="$t('Currency-Unit')"
                                  :rules="[
                                    (v) => !!v || $t('Please-Select-Currency-Type'),
                                  ]"
                                ></v-select>
                              </span>
                            </v-flex>
                            <v-flex xs12 sm4 md4>
                              <span>
                                <v-text-field
                                  v-model="otelData.OtelFiyat.GrupBilgi.Kur"
                                  :label="$t('Exchange-Rate-v2')"
                                  :rules="[(v) => !!v || $t('Please-Enter-Exchange-Rate')]"
                                ></v-text-field>
                              </span>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap align-center justify-start>
                            <v-flex xs12 sm1 md2>
                              <span
                                class="subheading red--text font-weight-bold"
                              >
                                {{$t('Buying')}} &nbsp;:</span
                              >
                            </v-flex>
                            <v-flex xs12 sm5 md6>
                              <span>
                                <v-select
                                  dense
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.ParaBirimiAlis
                                  "
                                  class="basic"
                                  :items="doviztipi"
                                  @input="getKur('alis')"
                                  item-text="Title"
                                  item-value="DovizKod"
                                  :label="$t('Currency-Unit')"
                                  :rules="[
                                    (v) => !!v || $t('Please-Select-Currency-Type'),
                                  ]"
                                ></v-select>
                              </span>
                            </v-flex>
                            <v-flex xs12 sm4 md4>
                              <span>
                                <v-text-field
                                  v-model="otelData.OtelFiyat.GrupBilgi.KurAlis"
                                  :label="$t('Exchange-Rate-v2')"
                                  :rules="[(v) => !!v || $t('Please-Enter-Exchange-Rate')]"
                                ></v-text-field>
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-tabs-items :value="active">
            <v-tab-item :id="'0'">
              <v-card flat color="grey lighten-4">
                <v-card-text>
                  <v-flex xs12 sm12 md12 pa-2>
                    <fiyatlistesi
                      v-if="LoadData"
                      v-model="otelData.OtelFiyat.FiyatKonumList"
                      v-bind:basliklar="headers"
                      v-bind:fiyatlist="odatipitems"
                      v-bind:allData="otelData"
                      v-bind:tip="active"
                    ></fiyatlistesi>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :id="'1'">
              <v-layout row wrap pa-2>
                <v-flex xs12 sm12 md6>
                  <v-card flat color="grey lighten-4">
                    <v-card-text>
                      <v-flex xs12 sm12 md12>
                        <v-card light style="min-height: 335px">
                          <v-card-title primary title>
                            <v-flex xs12 sm12 pt-2 md12>
                              <v-layout row wrap class="project overdue">
                                <v-toolbar
                                  flat=""
                                  size="120px"
                                  dark
                                  color="white"
                                >
                                  <v-toolbar-title>
                                    <span
                                      class="headline black--text font-weight-bold"
                                    >
                                       {{ $t('Commission-Details') }} 
                                    </span>
                                  </v-toolbar-title>
                                  <v-spacer></v-spacer>
                                </v-toolbar>
                              </v-layout>
                            </v-flex>
                          </v-card-title>
                          <v-card-text>
                            <v-layout row wrap pa-2>
                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap align-center justify-start>
                                  <v-flex xs12 sm3 md2>
                                    <span
                                      class="subheading red--text font-weight-bold"
                                      > {{ $t('Breakfast') }} &nbsp;:</span
                                    >
                                  </v-flex>
                                  <v-flex xs12 sm3 md3>
                                    <span>
                                      <v-text-field
                                        v-model="
                                          otelData.OtelFiyat.GrupBilgi
                                            .KSKahvalti
                                        "
                                        :label="$t('Sales')"
                                      ></v-text-field>
                                    </span>
                                  </v-flex>
                                  <v-flex xs12 sm3 md3>
                                    <span>
                                      <v-text-field
                                        v-model="
                                          otelData.OtelFiyat.GrupBilgi
                                            .KAKahvalti
                                        "
                                        :label="$t('Buying')"
                                      ></v-text-field>
                                    </span>
                                  </v-flex>
                                  <v-flex xs12 sm3 md4>
                                    <v-checkbox
                                      v-model="
                                        otelData.OtelFiyat.GrupBilgi
                                          .KomKahvaltiDahil
                                      "
                                      :label="$t('Excluding-breakfast')"
                                    ></v-checkbox>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap align-center justify-start>
                                  <v-flex xs12 sm3 md2>
                                    <span
                                      class="subheading red--text font-weight-bold"
                                      >Öğle&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</span
                                    >
                                  </v-flex>
                                  <v-flex xs12 sm3 md3>
                                    <span>
                                      <v-text-field
                                        v-model="
                                          otelData.OtelFiyat.GrupBilgi.KSOgle
                                        "
                                        :label="$t('Sales')"
                                      ></v-text-field>
                                    </span>
                                  </v-flex>
                                  <v-flex xs12 sm3 md3>
                                    <span>
                                      <v-text-field
                                        v-model="
                                          otelData.OtelFiyat.GrupBilgi.KAOgle
                                        "
                                        :label="$t('Buying')"
                                      ></v-text-field>
                                    </span>
                                  </v-flex>
                                  <v-flex xs12 sm3 md4>
                                    <v-checkbox
                                      v-model="
                                        otelData.OtelFiyat.GrupBilgi
                                          .KomOgleYemegiDahil
                                      "
                                      :label="$t('Excluding-lunch')"
                                    ></v-checkbox>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap align-center justify-start>
                                  <v-flex xs12 sm3 md2>
                                    <span
                                      class="subheading red--text font-weight-bold"
                                      >Akşam&nbsp;&nbsp;&nbsp;:</span
                                    >
                                  </v-flex>
                                  <v-flex xs12 sm3 md3>
                                    <span>
                                      <v-text-field
                                        v-model="
                                          otelData.OtelFiyat.GrupBilgi.KSAksam
                                        "
                                        :label="$t('Sales')"
                                      ></v-text-field>
                                    </span>
                                  </v-flex>
                                  <v-flex xs12 sm3 md3>
                                    <span>
                                      <v-text-field
                                        v-model="
                                          otelData.OtelFiyat.GrupBilgi.KAAksam
                                        "
                                        :label="$t('Buying')"
                                      ></v-text-field>
                                    </span>
                                  </v-flex>
                                  <v-flex xs12 sm3 md4>
                                    <v-checkbox
                                      v-model="
                                        otelData.OtelFiyat.GrupBilgi
                                          .KomAksamYemegiDahil
                                      "
                                      :label="$t('Excluding-dinner')"
                                    ></v-checkbox>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm3 md5>
                                <v-autocomplete
                                  hide-details
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi
                                      .KomHesapSecenegi
                                  "
                                  :label="$t('Calculate-Commission-Percentage')"
                                  item-text="t"
                                  item-value="v"
                                  :items="[
                                    { t: $t('Calculate-From-Sales-Price'), v: 0 },
                                    { t: $t('Calculate-From-Purchasing-Price'), v: 1 },
                                  ]"
                                >
                                </v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-text-field
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.KomTutar
                                  "
                                  :label="$t('Amount')"
                                  :hint="$t('Price-per-Capita')"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-text-field
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.KomTutarYuze
                                  "
                                  label="Tutar Yüzde"
                                  :hint="$t('Price-per-Capita')"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md8>
                                <v-checkbox
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.KomKDVHaric
                                  "
                                  @change="kdvShow()"
                                  :label="$t('Receive-Commission-from-Price-excluding-VAT')"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-text-field
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.KomKDVYuze
                                  "
                                  :disabled="kdvDisabled"
                                  :label="$t('VAT') + '%'"
                                ></v-text-field>
                              </v-flex>

                              <v-flex xs12 sm6 md8>
                                <v-checkbox
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.KonVerHaric
                                  "
                                  
                                  label="Komisyonu Konaklama Vergisi hariç hesapla"
                                ></v-checkbox>
                              </v-flex>
                              
                              <v-flex xs12 sm6 md8>
                                <v-checkbox
                                  v-model="
                                    otelData.OtelFiyat.GrupBilgi.KDVHaricFiyat
                                  "
                                  
                                  label="KDV Hariç Fiyatlar"
                                ></v-checkbox>
                              </v-flex>

                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-card flat color="grey lighten-4">
                    <v-card-text>
                      <v-flex xs12 sm12 md12>
                        <v-card light style="min-height: 335px">
                          <v-card-title primary title>
                            <v-flex xs12 sm12 pt-2 md12>
                              <v-layout row wrap class="project overdue">
                                <v-toolbar
                                  flat=""
                                  size="120px"
                                  dark
                                  color="white"
                                >
                                  <v-toolbar-title>
                                    <span
                                      class="headline black--text font-weight-bold"
                                    >
                                      {{ $t('Current-Details') }}
                                    </span>
                                  </v-toolbar-title>
                                  <v-spacer></v-spacer>
                                </v-toolbar>
                              </v-layout>
                            </v-flex>
                          </v-card-title>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-toolbar flat color="white">
                                  <v-flex xs12 sm8 md12>
                                    <cariaracomp
                                      v-model="cariValue"
                                    ></cariaracomp>
                                  </v-flex>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="primary"
                                    dark
                                    class="mb-0"
                                    @click="cariEkle()"
                                    >Cari Kod Ekle</v-btn
                                  >
                                </v-toolbar>
                                <v-data-table
                                  :headers="headersCari"
                                  :items="otelData.OtelFiyat.GrupBilgi.CariList"
                                  class="elevation-1"
                                >
                                  <template v-slot:items="props">
                                    <td>{{ props.item.kod }}</td>
                                    <td
                                      v-if="sayfayetki.Delete"
                                      class="justify-end layout pl-4"
                                    >
                                      <v-icon
                                        small
                                        @click="deleteItem(props.item)"
                                      >
                                        delete
                                      </v-icon>
                                    </td>
                                  </template>
                                </v-data-table>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item :id="'2'">
              <v-card flat color="grey lighten-4">
                <v-card-text>
                  <v-flex xs12 sm12 md12 pa-2>
                    <fiyatlistesi
                      v-if="co1LoadData"
                      v-model="otelData.OtelFiyat.FiyatKonumList"
                      v-bind:basliklar="headers"
                      v-bind:fiyatlist="odatipitems"
                      v-bind:allData="otelData"
                      v-bind:tip="active"
                    ></fiyatlistesi>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :id="'3'">
              <v-card flat color="grey lighten-4">
                <v-card-text>
                  <v-flex xs12 sm12 md12 pa-2>
                    <fiyatlistesi
                      v-if="co2LoadData"
                      v-model="otelData.OtelFiyat.FiyatKonumList"
                      v-bind:basliklar="headers"
                      v-bind:fiyatlist="odatipitems"
                      v-bind:allData="otelData"
                      v-bind:tip="active"
                    ></fiyatlistesi>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :id="'4'">
              <v-card flat color="grey lighten-4">
                <v-card-text>
                  <v-flex xs12 sm12 md12 pa-2>
                    <fiyatlistesi
                      v-if="co3LoadData"
                      v-model="otelData.OtelFiyat.FiyatKonumList"
                      v-bind:basliklar="headers"
                      v-bind:fiyatlist="odatipitems"
                      v-bind:allData="otelData"
                      v-bind:tip="active"
                    ></fiyatlistesi>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :id="'5'">
              <v-card flat color="grey lighten-4">
                <v-card-text>
                  <v-flex xs12 sm12 md12 pa-2>
                    <fiyatlistesi
                      v-if="co4LoadData"
                      v-model="otelData.OtelFiyat.FiyatKonumList"
                      v-bind:basliklar="headers"
                      v-bind:fiyatlist="odatipitems"
                      v-bind:allData="otelData"
                      v-bind:tip="active"
                    ></fiyatlistesi>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :id="'6'">
              <v-card flat color="grey lighten-4">
                <v-card-text>
                  <v-flex xs12 sm12 md12 pa-2>
                    <fiyatlistesi
                      v-if="ekYLoadData"
                      v-model="otelData.OtelFiyat.FiyatKonumList"
                      v-bind:basliklar="headers"
                      v-bind:fiyatlist="odatipitems"
                      v-bind:allData="otelData"
                      v-bind:tip="active"
                    ></fiyatlistesi>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import tarihim from "@/components/app/customcomp/tarihim";
import genelarama from "@/components/app/coper/comp/genelarama";
import geneltipara from "@/components/app/coper/comp/geneltipara";
import tool from "@/components/app/coper/tools";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import fiyatlistesi from "@/components/app/coper/tanitimlar/Otellistesi/comp/fiyatlistesi";
import auth from "@/api/auth";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog";
import helpers from "@/components/app/customcomp/helpers";
export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      cariValue: null,
      loadingmesaj: "Otel Fiyat",
      loadingdialog: false,
      islemTipi: null,
      otelLoadItems: {
        Id: {},
      },
      el: null,
      valid: true,
      dialogCari: false,
      kdvDisabled: true,
      tabShow: true,
      co1LoadData: false,
      co2LoadData: false,
      co3LoadData: false,
      co4LoadData: false,
      ekYLoadData: false,
      doviztipi: [],
      kurList: [],
      LoadData: false,
      headers: [],
      fiyatitems: [],
      odatipitems: [],
      text1: "",
      snackbar: false,
      active: "",
      currentItem: null,
      otelData: {
        Id: {
          FiyatKodu: {
            id: null,
            kod: null,
            isim: null,
            tip: 0,
            intField: null,
          },
          SaticiKodu: {
            id: 0,
            kod: null,
            isim: null,
            tip: 0,
            intField: null,
          },
          TurOperatoru: {
            id: 0,
            kod: null,
            isim: null,
            tip: 0,
            intField: null,
          },
          Donem1: null,
          Donem2: null,
          Pansiyon: 0,
        },
        OtelFiyat: {
          GrupBilgi: {
            RP: 0,
            ParaBirimi: null,
            Kur: 0.0,
            ParaBirimiAlis: null,
            KurAlis: 0.0,
            KomKDVHaric: false,
            KomKahvaltiDahil: false,
            KomOgleYemegiDahil: false,
            KomAksamYemegiDahil: false,
            KomKDVYuze: 0,
            KomTutarYuze: 0,
            KomTutar: 0,
            KomHesapSecenegi: 0,
            KSKahvalti: 0,
            KAKahvalti: 0,
            KSOgle: 0,
            KAOgle: 0,
            KSAksam: 0,
            KAAksam: 0,
            WebActive: false,
            KonVerHaric: false,
            KDVHaricFiyat:false,
            CariList: [],
          },
          FiyatKonumList: [],
        },
      },
      headersCari: [
        {
          text: "Cari Adı",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t('Process'),
          align: "right",
          value: "actions",
          sortable: false,
        },
      ],
      RPitems: [
        {
          text: "R",
          value: 0,
        },
        {
          text: "P",
          value: 1,
        },
      ],
      Pansiyonitems: [
        {
          text: "OB",
          value: 0,
        },
        {
          text: "BB",
          value: 1,
        },
        {
          text: "HB",
          value: 2,
        },
        {
          text: "FB",
          value: 3,
        },
        {
          text: "FF",
          value: 4,
        },
        {
          text: "FC",
          value: 5,
        },
        {
          text: "AI",
          value: 6,
        },
        {
          text: "UAI",
          value: 7,
        },
      ],
    };
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      //this.el = this.$refs.fab.$el;
      if (this.$route.query.islem == "get") {
        this.islemTipi = "get";
        var otelReq = window.localStorage.getItem("otelLoadRequest");

        this.otelLoadItems.Id = Object.assign(
          this.otelData.Id,
          JSON.parse(otelReq)
        );
        this.otelLoadItems.Id.SaticiKodu = this.otelLoadItems.Id.Otel;
        delete this.otelLoadItems.Id.Otel;

        this.otelData.Id = Object.assign(this.otelData.Id, JSON.parse(otelReq));
        this.otelData.Id.SaticiKodu.kod = this.otelData.Id.Otel.kod;
        delete this.otelData.Id.Otel;
        this.otelLoad();
      } else {
        this.islemTipi = "new";
        this.getCurrency();
      }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  components: {
    tarihim,
    genelarama,
    geneltipara,
    tool,
    snackbarcomp,
    fiyatlistesi,
    loadingcomp,
    cariaracomp,
    yetkidialog,
  },
  beforeMount: beforeMount,
  methods: {
    cariEkle() {
      if (this.cariValue != null) {
        this.otelData.OtelFiyat.GrupBilgi.CariList.push({
          id: "",
          kod: this.cariValue,
          isim: "",
          tip: 0,
          intField: null,
        });
        this.cariValue = "";
      }
    },
    close() {
      this.dialogCari = false;
    },
    save() {
      this.close();
    },
    deleteItem(item) {
      const index = this.otelData.OtelFiyat.GrupBilgi.CariList.indexOf(item);
      this.otelData.OtelFiyat.GrupBilgi.CariList.splice(index, 1);
    },
    kdvShow() {
      if (this.otelData.OtelFiyat.GrupBilgi.KomKDVHaric == true) {
        this.kdvDisabled = false;
      } else {
        this.kdvDisabled = true;
      }
    },
    tabShowView() {
      if (this.otelData.OtelFiyat.GrupBilgi.RP == 1) {
        this.tabShow = false;
      } else {
        this.tabShow = true;
      }
    },
    activeTab(tabNumber) {
      if (tabNumber == 0) {
        this.active = "0";
        this.co1LoadData = false;
        this.co2LoadData = false;
        this.co3LoadData = false;
        this.co4LoadData = false;
        this.ekYLoadData = false;
        this.LoadData = true;
      } else if (tabNumber == 2) {
        this.co1LoadData = true;
        this.co2LoadData = false;
        this.co3LoadData = false;
        this.co4LoadData = false;
        this.ekYLoadData = false;
        this.LoadData = false;
      } else if (tabNumber == 3) {
        this.co1LoadData = false;
        this.co2LoadData = true;
        this.co3LoadData = false;
        this.co4LoadData = false;
        this.ekYLoadData = false;
        this.LoadData = false;
      } else if (tabNumber == 4) {
        this.co1LoadData = false;
        this.co2LoadData = false;
        this.co3LoadData = true;
        this.co4LoadData = false;
        this.ekYLoadData = false;
        this.LoadData = false;
      } else if (tabNumber == 5) {
        this.co1LoadData = false;
        this.co2LoadData = false;
        this.co3LoadData = false;
        this.co4LoadData = true;
        this.ekYLoadData = false;
        this.LoadData = false;
      } else if (tabNumber == 6) {
        this.co1LoadData = false;
        this.co2LoadData = false;
        this.co3LoadData = false;
        this.co4LoadData = false;
        this.ekYLoadData = true;
        this.LoadData = false;
      }
    },
    kaydet() {
      if (this.otelData.Id.FiyatKodu.kod == null) {
        this.text1 = this.$t('Hotel-Price-Code-cannot-left-blank');
        this.snackbar = true;
        return false;
      }
      if (this.otelData.Id.SaticiKodu.kod == null) {
        this.text1 = this.$t('Hotel-Cannot-Left-Blank');
        this.snackbar = true;
        return false;
      }

      if (this.$refs.GenelBilgiler.validate()) {
        var bastarih = new Date(this.otelData.Id.Donem1);
        var bittarih = new Date(this.otelData.Id.Donem2);

        if (bastarih <= bittarih) {
          this.loadingdialog = true;
          if (this.otelData.Id.TurOperatoru.kod == null) {
            this.otelData.Id.TurOperatoru.kod = "STD";
          }
          let params = this.otelData;
          tool.http_post(this, "OtelFiyatInsert", params).then(
            (response) => {
              if (response.body.Status == true) {
                  if (response.body.ErrorList != null) {
                    if (this.otelData.Id.TurOperatoru.kod == "STD") {
                      this.otelData.Id.TurOperatoru.kod = null;
                    }
                    this.text1 = response.body.ErrorList[0];
                    this.snackbar = true;
                    this.loadingdialog = false;
                  } else {
                    var url = "#/coper/tanitimlar/Otellistesi/otellistesi";
                    window.open(url, "_self");
                  }
            
              } else {
               if (this.otelData.Id.TurOperatoru.kod == "STD") {
                  this.otelData.Id.TurOperatoru.kod = null;
                }
                this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
                this.loadingdialog = false;
              }
            },
            (response) => {
              this.text1 = "Hata Oluştu, tekrar deneyiniz";
              this.snackbar = true;
              this.loadingdialog = false;
            }
          );
        }
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    },
    guncelle() {
      this.loadingdialog = true;

      let params = this.otelData;
      tool.http_post(this, "OtelFiyatEdit", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.loadingdialog = false;
            var url = "#/coper/tanitimlar/Otellistesi/otellistesi";
            window.open(url, "_self");
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingdialog = false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingdialog = false;
        }
      );
    },
    getKur(val) {
      if (this.kurList.length == 0) {
        if (this.kayitTarihi == null) {
          this.kayitTarihi = tool.Now_yyyy_MM_dd();
        }

        tool
          .http_post(this, "KurAra", {
            tarih: tool.Now_yyyy_MM_dd(),
          })
          .then(
            (response) => {
              this.kurList = response.body;
              this.selectKur(val);
            },
            (response) => {
              this.text1 = "Service Unavailable-Döviz Coper";
              this.snackbar = true;
            }
          );
      } else {
        this.selectKur(val);
      }
    },
    selectKur(tip) {
      if (tip == "satis") {
        var resultSatis = this.kurList.find(this.paraAraSatis);
        if (resultSatis == undefined) {
          this.otelData.OtelFiyat.GrupBilgi.Kur = 1;
        } else {
          this.otelData.OtelFiyat.GrupBilgi.Kur = resultSatis.kur;
        }
      } else if (tip == "alis") {
        var resultAlis = this.kurList.find(this.paraAraAlis);
        if (resultAlis == undefined) {
          this.otelData.OtelFiyat.GrupBilgi.KurAlis = 1;
        } else {
          this.otelData.OtelFiyat.GrupBilgi.KurAlis = resultAlis.kur;
        }
      }
    },
    getCurrency() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        CompanyCode: credentials.SirketKodu,
      };
      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
    otelLoad() {
      //Örnek Request
      let params = this.otelLoadItems;
      tool.http_post(this, "OtelFiyatLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.otelData.OtelFiyat = response.body.data;
            this.headers.push({
              text: "",
              value: "",
              sortable: false,
            });
            for (
              var i = 0;
              i < this.otelData.OtelFiyat.FiyatKonumList.length;
              i++
            ) {
              this.headers.push({
                text: this.otelData.OtelFiyat.FiyatKonumList[
                  i
                ].OdaKonum.toUpperCase(),
                value: this.otelData.OtelFiyat.FiyatKonumList[i].OdaKonum,
                sortable: false,
              });
            }
            for (
              var k = 0;
              k <
              this.otelData.OtelFiyat.FiyatKonumList[0].OdaTipFiyatList.length;
              k++
            ) {
              this.odatipitems.push(
                this.otelData.OtelFiyat.FiyatKonumList[0].OdaTipFiyatList[k]
              );
            }

            this.getCurrency();
            this.activeTab(0);
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
    fiyatKonumList() {
      if (this.otelData.Id.SaticiKodu.kod.length <= 0) {
        this.odatipitems = [];
        this.headers = [];
      } else {
        let params = {
          OtelKod: this.otelData.Id.SaticiKodu.kod,
        };
        tool.http_post(this, "OtelFreeFiyatKonumList", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.odatipitems = [];
              this.otelData.OtelFiyat.FiyatKonumList = response.body.data;
              this.fiyatitems = response.body.data;
              this.headers.push({
                text: "",
                value: "",
                sortable: false,
                width: "10%",
              });
              for (var i = 0; i < this.fiyatitems.length; i++) {
                this.headers.push({
                  text: this.fiyatitems[i].OdaKonum.toUpperCase(),
                  value: this.fiyatitems[i].OdaKonum,
                  sortable: false,
                  width: "20%",
                });
              }
              for (
                var k = 0;
                k < this.fiyatitems[0].OdaTipFiyatList.length;
                k++
              ) {
                this.odatipitems.push(this.fiyatitems[0].OdaTipFiyatList[k]);
              }
              this.activeTab(0);
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
            this.text1 = "Hata Oluştu, tekrar deneyiniz";
            this.snackbar = true;
          }
        );
      }
    },
    paraAraSatis: paraAraSatis,
    paraAraAlis: paraAraAlis,
  },
};

function beforeMount() {}

function paraAraSatis(paraBirimi) {
  return paraBirimi.paraBirimi == this.otelData.OtelFiyat.GrupBilgi.ParaBirimi;
}

function paraAraAlis(paraBirimi) {
  return (
    paraBirimi.paraBirimi == this.otelData.OtelFiyat.GrupBilgi.ParaBirimiAlis
  );
}
</script>

<style scoped>
.basic {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
